/** Figma filters / dim selection modal (node 75644:10729 area) */
export const PLAN_DIM_MODAL_WIDTH = '640px';
export const PLAN_DIM_MODAL_RADIUS = '16px';
export const PLAN_DIM_MODAL_SIDEBAR_WIDTH = '180px';
export const PLAN_DIM_MODAL_SIDEBAR_BG = '#F5F0FF';
export const PLAN_DIM_MODAL_SIDEBAR_ACTIVE_BG = '#EDE9FE';
export const PLAN_DIM_MODAL_CLEAR_COLOR = '#FE552F';
